import { render, staticRenderFns } from "./SensorsEdit.vue?vue&type=template&id=79b9e972&scoped=true"
import script from "./SensorsEdit.vue?vue&type=script&lang=js"
export * from "./SensorsEdit.vue?vue&type=script&lang=js"
import style0 from "./SensorsEdit.vue?vue&type=style&index=0&id=79b9e972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9e972",
  null
  
)

export default component.exports